import { render, staticRenderFns } from "./ProductHistoryList.vue?vue&type=template&id=034486ae"
import script from "./ProductHistoryList.vue?vue&type=script&lang=js"
export * from "./ProductHistoryList.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryList.vue?vue&type=style&index=0&id=034486ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports